import React, { useContext, useRef, useState } from "react";
import { Button } from "primereact/button";
import { LayoutContext } from "../../layout/context/layoutcontext";
import { Link, useNavigate } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import "../../assets/styles/hover.scss";
import { Menu } from "primereact/menu";
import "../../assets/styles/hover.scss";
import { useAuth } from "../../utils/auth";
import authService from "../../services/auth/auth.service";
import Header from "./Header";

interface ItemDto {
  name: string;

  description: string;

  image: string;

  link: string;

  documentPath?: string;
}

const cardData = [
  {
    imgSrc: "/images/landing-page/hesaplama.jpg",

    title: "Hesaplama",

    description: "Yeşil dönüşüm ve sürdürülebilirlik politikalarınızı planlamak için gerekli hesaplamalar",

    path: "/app/karbonayakizi"
  },

  {
    imgSrc: "/images/landing-page/rapor.jpg",

    title: "Raporlama",

    description: "Sürdürülebilirlik, çevresel performans, iyileştirme ve malzeme-kaynak yönetimi raporları",

    path: "/app/rapor"
  },

  {
    imgSrc: "/images/landing-page/analiz.jpg",

    title: "Analiz",

    description:
      "Yeşil dönüşüm olgunluk analizi, dijital dönüşüm endeksi ve sektör/bölge/ülke genelindeki istatistikler ve raporlar",

    path: "/app/grafik"
  },

  {
    imgSrc: "/images/landing-page/egitim.jpg",

    title: "Eğitim",

    description: "Sürdürülebilirlik, yenilikçilik, teknoloji, kurumsal gelişim ve iklim değişikliğine uyum eğitimleri",

    path: "/app/egitim"
  },

  {
    imgSrc: "/images/landing-page/afad.jpg",

    title: "İş Sürekliliği Planı",

    description:
      "Afet durumunda sanayi kuruluşlarının kesintisiz faaliyet göstermesi için AFAD ve Sanayi Bakanlığı ile geliştirdiğimiz iş birliği çalışmaları",

    path: "/app/is-surekliligi"
  },

  {
    imgSrc: "/images/landing-page/haber.jpg",

    title: "OSBÜK Bülten",

    description: "Türkiye'deki organize sanayi bölgeleriyle ilgili güncel haberler, projeler ve sektörel gelişmeler",

    path: "/app/bulten"
  }
];

const crouselItems: any = [
  {
    name: "Stratejik Plan Raporu",

    description: "Paydaş beklenti ve ihtiyaç analizi (2.10.2024)",

    image: "/images/landing-page/stratejikplan.jpg",

    documentPath: "/belgeler/strateji-belge.pdf"
  },

  {
    name: "Stratejik Plan Çalışması",

    description: "Stratejik plan çalışmaları ve değerlendirmeler",

    image: "/images/landing-page/stratejik-plan.jpg",

    link: "/app/stratejik-plan"
  },

  {
    name: "Forum",

    description: "Forum",

    image: "/images/landing-page/forum.jpg",

    link: "/app/forum-homepage"
  },

  {
    name: "Hesaplama",

    description: "Gerekli hesaplamalara buradan ulaşabilirsiniz.",

    image: "/images/landing-page/hesaplama.jpg",

    link: "/app/karbonayakizi"
  },

  {
    name: "Raporlama",

    description: "Sürdürülebilirlik ve çevresel performans raporları.",

    image: "/images/landing-page/rapor.jpg",

    link: "/app/rapor"
  },

  {
    name: "Analiz",

    description: "Yeşil dönüşüm olgunluk analizi ve istatistikler.",

    image: "/images/landing-page/analiz.jpg",

    link: "/app/grafik"
  },

  {
    name: "Eğitim",

    description: "Geniş kapsamlı eğitim fırsatları",

    image: "/images/landing-page/egitim.jpg",

    link: "/app/egitim"
  },

  {
    name: "İş Sürekliliği",

    description: "Amaçlar çalıştay çalışmaları (31 Ekim - 3 Kasım 2024)",

    image: "/images/landing-page/afad.jpg",

    link: "/app/is-surekliligi"
  },

  {
    name: "OSBÜK Bülten",

    description: "Güncel OSB haberleri bülteni",

    image: "/images/landing-page/haber.jpg",

    link: "/app/bulten"
  }
];

const LandingPage = () => {
  const [isHidden, setIsHidden] = useState(false);

  const { layoutConfig } = useContext(LayoutContext);

  const menuRef = useRef<HTMLElement | null>(null);
  const profileMenu = useRef<Menu>(null);

  const navigate = useNavigate();

  const auth = useAuth();

  const toggleMenuItemClick = () => {
    setIsHidden((prevState) => !prevState);
  };

  const handleDownload = (documentPath: string) => {
    const link = document.createElement("a");
    link.href = documentPath;
    link.download = documentPath.split("/").pop() || "document.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const itemTemplate = (item: ItemDto) => {
    const handleClick = (e: React.MouseEvent) => {
      e.preventDefault();
      if (item.name === "Stratejik Plan Raporu" && item.documentPath) {
        window.open(item.documentPath, "_blank");
      } else if (item.link) {
        navigate(item.link);
      }
    };

    return (
      <a
        href={item.link || "#"}
        onClick={handleClick}
        className="border-round-2xl border-3 border-primary-500 surface-border border-round m-2 text-center py-3 px-3 h-auto block transition-all duration-300 ease-in-out hover:scale-105 hover:shadow-3"
      >
        <div className="mb-3">
          <img src={item.image} alt={item.name} className="w-8rem h-8rem object-cover rounded-full mx-auto shadow-2" />
        </div>

        <div className="text-center">
          <h4 className="mb-2 text-xl font-semibold" style={{ maxHeight: "2em", minHeight: "2em" }}>
            {item.name}
          </h4>

          <p
            className="text-sm overflow-hidden text-ellipsis line-clamp-2"
            style={{ maxHeight: "3em", minHeight: "3em" }}
          >
            {item.description}
          </p>
        </div>
      </a>
    );
  };

  const responsiveOptions = [
    {
      breakpoint: "1024px",

      numVisible: 5,

      numScroll: 5
    },

    {
      breakpoint: "768px",

      numVisible: 2,

      numScroll: 2
    },

    {
      breakpoint: "560px",

      numVisible: 1,

      numScroll: 1
    }
  ];

  //const username = localStorage.getItem("userName");

  const [menuVisible, setMenuVisible] = useState(false);

  const items = [
    {
      label: "Giriş Yap",

      icon: "pi pi-sign-in",

      command: () => navigate("/loginsebis"),

      visible: !auth.getUser().access_token
    },

    {
      label: "Kayıt Ol",

      icon: "pi pi-user-plus",

      command: () => {
        auth.removeUserFromStorage();

        navigate("/register", { replace: true });
      },

      visible: !auth.getUser().access_token
    }
  ];

  const profileItems = [
    {
      label: "Profil",
      icon: "pi pi-user",
      command: () => {
        navigate("/app/profile");
      }
    },
    {
      label: "Ana Sayfa",
      icon: "pi pi-home",
      command: () => {
        navigate("/app/homepage");
      }
    },
    {
      label: "Çıkış Yap",
      icon: "pi pi-sign-out",
      command: async () => {
        await authService.RevokeRefreshToken({ token: auth.getUser().refresh_token });
        auth.removeUserFromStorage();
        navigate("/loginsebis", { replace: true });
      }
    }
  ];

  const [sliderItems, setSliderItems] = useState<ItemDto[]>([]);

  return (
    <div className="surface-0 flex justify-content-center">
      <div id="home" className="landing-wrapper p-fluid overflow-hidden">
        {/* <div

          className="py-1 px-4 mx-0 flex align-items-center justify-content-between relative lg:static"

          style={{ backgroundColor: "#114d6b", height: "60px" }}

        > */}

        <div className="py-2 px-4 mx-0 md:mx-6 lg:mx-8 lg:px-8 flex align-items-center justify-content-between relative lg:static">
          <Link to="/" className="flex align-items-center">
            <img src="/images/logoosbuk.png" alt="OSBÜK" height="50" className="mr-3 lg:mr-3" />

            {/* <span className="text-900 font-medium text-2xl line-height-3 mr-8">SEBİS</span> */}
          </Link>

          <div className="lg:flex ml-auto">
            <div className="md:flex hidden">
              {!auth.getUser().access_token ? (
                <>
                  <Button
                    label="Giriş Yap"
                    text
                    rounded
                    className="border-none font-light line-height-2 text-blue-500 md:mr-2"
                    style={{
                      backgroundColor: "#ffffff", // White background

                      color: "#114d6b", // Text color #114d6b

                      border: "3px solid #114d6b",

                      height: "40px",

                      width: "120px"
                    }}
                    onClick={() => navigate("/loginsebis")}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />

                  <Button
                    label={"Kayıt Ol"}
                    rounded
                    className="border-none font-light line-height-2 bg-blue-500 text-white"
                    style={{
                      backgroundColor: "#ffffff", // White background

                      color: "#114d6b", // Text color #114d6b

                      border: "3px solid #114d6b",

                      height: "40px",

                      width: "120px"
                    }}
                    onClick={() => navigate("/register")}
                    onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.transform = "scale(1.05)";
                    }}
                    onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                      e.currentTarget.style.transform = "scale(1)";
                    }}
                  />
                </>
              ) : (
                <div className="flex align-items-center gap-2">
                  {/* Kullanıcı Adı */}
                  {auth.getUser()?.firstName && <p className="m-0 font-medium text-lg">{auth.getUser()?.firstName || ""}</p>}
                  {auth.getUser()?.lastName && <p className="m-0 font-medium text-lg">{auth.getUser()?.lastName || ""}</p>}

                  {/* Profil İkonu ve Menü */}
                  <div className="flex justify-content-center align-items-center">
                    <Menu model={profileItems} popup ref={profileMenu} />
                    <Button
                      label="Profil"
                      rounded
                      className="border-none font-light line-height-2 bg-blue-500 text-white"
                      style={{
                        backgroundColor: "#ffffff", // White background
                        color: "#114d6b", // Text color #114d6b
                        border: "3px solid #114d6b",
                        height: "40px",
                        width: "120px"
                      }}
                      onClick={(e) => profileMenu?.current?.toggle(e)}
                      onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <div className="md:hidden">
              {!auth.getUser().access_token ? (
                <>
                  <Button
                    icon="pi pi-bars"
                    onClick={() => setMenuVisible(!menuVisible)}
                    className="p-button-rounded p-button-outlined"
                    style={{ backgroundColor: "#ffffff", color: "#114d6b", border: "3px solid #114d6b" }}
                  />

                  {menuVisible && (
                    <Menu
                      model={items}
                      className="absolute z-5 w-full"
                      style={{
                        top: "50px", // Düğmeden biraz aşağıda

                        left: "0",

                        backgroundColor: "#fff",

                        border: "1px solid #ddd"
                      }}
                    />
                  )}
                </>
              ) : (
                <div className="flex align-items-center gap-2">
                  {/* Kullanıcı Adı */}
                  {auth.getUser()?.firstName && <p className="m-0 font-medium text-lg">{auth.getUser()?.firstName || ""}</p>}
                  {auth.getUser()?.lastName && <p className="m-0 font-medium text-lg">{auth.getUser()?.lastName || ""}</p>}

                  {/* Profil İkonu ve Menü */}
                  <div className="flex justify-content-center align-items-center">
                    <Menu model={profileItems} popup ref={profileMenu} />
                    <Button
                      label="Profil"
                      rounded
                      className="border-none font-light line-height-2 bg-blue-500 text-white"
                      style={{
                        backgroundColor: "#ffffff", // White background
                        color: "#114d6b", // Text color #114d6b
                        border: "3px solid #114d6b",
                        height: "40px",
                        width: "120px"
                      }}
                      onClick={(e) => profileMenu?.current?.toggle(e)}
                      onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.currentTarget.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {
                        e.currentTarget.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* <div style={{ backgroundColor: "#114d6b", height: "4px" }}>

          <br />

        </div> */}

        {/* <div

          id="features"

          className="flex justify-content-center align-items-center py-4 px-4 lg:px-6 border-green-300 rounded-lg shadow-md"

          style={{

            backgroundColor: "#114d6b",

            backgroundImage: "url('images/bgi.webp')",

            backgroundSize: "cover",

            backgroundPosition: "center",

            backgroundRepeat: "no-repeat",

            height: "25rem"

          }}

        >

          <div className="text-center">

            <h1 className="text-3xl font-bold" style={{ color: "#114d6b" }}>

              YEŞİL DÖNÜŞÜM VE SÜRDÜRÜLEBİLİRLİK MERKEZİ

            </h1>

            <p className="mt-2" style={{ color: "#114d6b" }}>

              Organize Sanayi Bölgelerine (OSB) yeşil dönüşümde rehberlik ediyor, sürdürülebilirlik alanında sağlam

              adımlarla ilerleyen bir topluluk inşa ediyoruz.

            </p>

          </div>

        </div> */}

        {/* <div

          id="features"

          className="flex justify-center items-center py-8 px-6 rounded-lg shadow-md relative overflow-hidden" // py-8 daha fazla dikey boşluk

          style={{

            backgroundColor: "#114d6b", 

            backgroundImage: "url(images/bgi.png)",

            backgroundSize: "cover",

            backgroundPosition: "center",

            backgroundRepeat: "no-repeat",

            height: "25rem"

          }}

        >

          <div className="absolute inset-0 bg-black opacity-40"></div>

          <div className="text-center relative z-10">

            <h1 className="text-3xl font-bold text-white">YEŞİL DÖNÜŞÜM VE SÜRDÜRÜLEBİLİRLİK MERKEZİ</h1>

            <p className="mt-4 text-white">

              Organize Sanayi Bölgelerine (OSB) yeşil dönüşümde rehberlik ediyor, sürdürülebilirlik alanında sağlam

              adımlarla ilerleyen bir topluluk inşa ediyoruz.

            </p>

          </div>

        </div> */}

        <Header />

        {/* <div id="header" className="py-2 px-2 lg:px-4 mt-2 mx-0 lg:mx-4">

          <div className="grid grid-nogutter align-items-center">

            <div className="col-12 md:col-6">

              <h1 className="text-4xl font-bold text-800 mb-3 text-center">YEŞİL DÖNÜŞÜM VE SÜRDÜRÜLEBİLİRLİK MERKEZİ</h1>

              <p className="text-lg text-600 mb-4 text-center">

                Organize Sanayi Bölgelerine (OSB) yeşil dönüşümde rehberlik ediyor, sürdürülebilirlik alanında sağlam

                adımlarla ilerleyen bir topluluk inşa ediyoruz.

              </p>

              <Button

                label="Giriş Yap"

                text

                rounded

                className="border-none font-light line-height-2 bg-blue-500 text-white "

                style={{

                    backgroundColor: "#ffffff", // White background

                    color: "#114d6b", // Text color #114d6b

                    border: "3px solid #114d6b",

                    height: "40px",

                    width: "120px"

                  }}

                onClick={() => navigate("/loginsebis")}

                onMouseEnter={(e: React.MouseEvent<HTMLButtonElement>) => {

                  e.currentTarget.style.transform = "scale(1.05)";

                }}

                onMouseLeave={(e: React.MouseEvent<HTMLButtonElement>) => {

                  e.currentTarget.style.transform = "scale(1)";

                }}

              />

            </div>



            <div className="col-12 md:col-6">

              <img

                src="images/landing-page/hero2.png"

                alt="Hero Image"

                className="w-full h-auto rounded-lg shadow-2"

              />

            </div>

          </div>

        </div> */}

        {/* <div

          id="hero"

          className="flex flex-column pt-4 px-4 lg:px-8 overflow-hidden"

          style={{

            background:

              "linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), radial-gradient(77.36% 256.97% at 77.36% 57.52%, #EEEFAF 0%, #C3E3FA 100%)",

            clipPath: "ellipse(150% 87% at 93% 13%)"

          }}

        >

          <div className="mx-4 md:mx-8 mt-0 md:mt-4">

            <h1 className="text-4xl font-bold text-gray-900 line-height-2">

              YEŞİL DÖNÜŞÜM VE SÜRDÜRÜLEBİLİRLİK MERKEZİ

            </h1>

            <p className="font-normal text-2xl line-height-3 md:mt-3 text-gray-700">

              Organize Sanayi Bölgelerine (OSB) yeşil dönüşümde rehberlik ediyor, sürdürülebilirlik alanında sağlam

              adımlarla ilerleyen bir topluluk inşa ediyoruz.

            </p>

          </div>

          <div className="flex justify-content-center md:justify-content-end">

            <img src="images/landing-page/hero3.webp" alt="Hero Image" className="w-9 md:w-8" />

          </div>

        </div> */}

        <div id="highlights" className="py-4 px-4 mx-0 lg:mx-8">
          <div className="grid justify-content-center">
            <div className="grid">
              {cardData.map((card, index) => (
                <div className="col-12 md:col-6 lg:col-4 " key={index}>
                  <div
                    style={{
                      height: "130px",

                      padding: "2px",

                      borderRadius: "10px",

                      background:
                        "linear-gradient(90deg, rgba(145,226,237,0.2),rgba(251, 199, 145, 0.2)), linear-gradient(180deg, rgba(253, 228, 165, 0.2), rgba(172, 180, 223, 0.2))"
                    }}
                  >
                    <div
                      className="p-3 surface-card h-full cursor-pointer hover-card"
                      style={{ borderRadius: "8px" }}
                      onClick={() => navigate(card.path)}
                    >
                      <div className="flex align-items-center">
                        <img src={card.imgSrc} className="shadow-2 w-6rem h-6rem mr-3" alt={card.title} />

                        <div className="flex flex-column justify-content-center">
                          <h5 className="mb-1 text-900 text-lg">{card.title}</h5>

                          <span className="text-600 text-sm">{card.description}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div id="highlights" className="py-4 px-4 mx-0 lg:mx-8">
          <div className="grid justify-content-center">
            <div
              className="col-12 mt-2 mb-2 md:p-4"
              style={{
                borderRadius: "20px",

                background:
                  "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), radial-gradient(77.36% 256.97% at 77.36% 57.52%, #EFE1AF 0%, #C3DCFA 100%)"
              }}
            >
              <div className="flex flex-column justify-content-center align-items-center text-center px-3 py-3 md:py-0">
                <a href="/app/baskan-mesaj">
                  <img
                    src="images/baskanmesajnew.png"
                    alt="Baskan Mesaj"
                    className="w-full h-auto" // Makes the image responsive
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* <div id="features" className="py-4 px-4 mt-5 mx-0">

          <div className="flex align-items-center justify-content-center">

            <a href="/app/baskan-mesaj">

              <img

                src="images/baskanmesaj.jpg"

                alt="Baskan Mesaj"

                className="w-full h-auto" // Makes the image responsive

              />

            </a>

          </div>

        </div> */}

        <div
          id="features"
          className="py-4 px-4 mt-6 mx-0 lg:mx-8 bg-gradient-to-r from-blue-800 via-blue-700 to-blue-600 rounded-lg shadow-xl"
        >
          <Carousel
            value={crouselItems}
            //value={sliderItems}
            numVisible={6}
            responsiveOptions={responsiveOptions}
            className="rounded-lg"
            circular
            autoplayInterval={3000}
            itemTemplate={itemTemplate}
          />
        </div>

        <div id="highlights" className="py-4 px-4 mx-0 lg:mx-8">
          <div className="text-center">
            <h2 className="text-900 font-normal mb-2">Topluluk ve Bilgi Paylaşımı</h2>

            <span className="text-600 text-2xl">
              OSBÜK ve diğer kullanıcılarla bilgi alışverişi yapabilir, sektörel gelişmeleri tartışabilirsiniz.
            </span>
          </div>

          <div className="grid mt-4 pb-2 md:pb-4">
            <div
              className="flex justify-content-center col-12 lg:col-6 bg-cyan-100 p-0 flex-order-1 lg:flex-order-0"
              style={{ borderRadius: "10px" }}
            >
              <div className="w-8 flex justify-content-center align-items-center">
                <img src="images/landing-page/forum-page.jpg" className="w-7" alt="forum-homepage" />
              </div>
            </div>

            <div className="col-12 lg:col-6 my-auto flex flex-column lg:align-items-end text-center lg:text-right">
              <div
                className="flex align-items-center justify-content-center bg-cyan-200 align-self-center lg:align-self-end"
                style={{
                  width: "4.2rem",

                  height: "4.2rem",

                  borderRadius: "10px"
                }}
              >
                <i className="pi pi-fw pi-comments text-5xl text-cyan-700"></i>
              </div>

              <h2 className="line-height-1 text-900 text-4xl font-normal">Forum</h2>

              <span className="text-700 text-xl line-height-3 ml-0 md:ml-2" style={{ maxWidth: "650px" }}>
                Forum alanımızda sorularınızı sorabilir, diğer kullanıcıların sorularına yanıt vererek bilgi
                paylaşımında bulunabilir ve sektörel konular hakkında etkileşimde bulunabilirsiniz.
              </span>

              <Button
                className="w-6 md:w-4 mt-4 bg-cyan-200 text-cyan-700 border-none "
                label="Sayfaya Git"
                icon="pi pi-check"
                onClick={() => navigate("/app/forum-homepage")}
              />
            </div>
          </div>

          <div className="grid my-4 py-2 md:py-4">
            <div className="col-12 lg:col-6 my-auto flex flex-column text-center lg:text-left lg:align-items-start">
              <div
                className="flex align-items-center justify-content-center bg-yellow-200 align-self-center lg:align-self-start"
                style={{
                  width: "4.2rem",

                  height: "4.2rem",

                  borderRadius: "10px"
                }}
              >
                <i className="pi pi-fw pi-globe text-5xl text-yellow-700"></i>
              </div>

              <h2 className="line-height-1 text-900 text-4xl font-normal">Merkez ile Yapay Zeka Sohbeti</h2>

              <span className="text-700 text-xl line-height-3 mr-0 md:mr-2" style={{ maxWidth: "650px" }}>
                Merkez ile Yapay Zeka Sohbeti alanımızda, OSBÜK hakkında bilgi alabilir, yeşil dönüşüm ve teknolojik
                gelişmelerle ilgili sorularınızı sorabilir, kanunlar ve düzenlemeler hakkında detaylı yanıtlar
                alabilirsiniz.
              </span>

              <Button
                className="w-6 md:w-4 mt-4 bg-yellow-200 text-yellow-700 border-none "
                label="Sayfaya Git"
                icon="pi pi-check"
                onClick={() => navigate("/app/yapay-zeka")}
              />
            </div>

            <div
              className="flex justify-content-center flex-order-1 sm:flex-order-2 col-12 lg:col-6 bg-yellow-100 p-0"
              style={{ borderRadius: "10px" }}
            >
              <div className="w-8 flex justify-content-center align-items-center">
                <img src="/images/landing-page/yz-sohbet.jpg" className="w-7" alt="yz-sohbet" />
              </div>
            </div>
          </div>

          <div className="grid my-4 pt-2 md:pt-4">
            <div
              className="flex justify-content-center col-12 lg:col-6 bg-blue-100 p-0 flex-order-1 lg:flex-order-0"
              style={{ borderRadius: "10px" }}
            >
              <div className="w-8 flex justify-content-center align-items-center">
                <img src="images/landing-page/stratejik-plan-page.jpg" className="w-7" alt="stratejik-plan" />
              </div>
            </div>

            <div className="col-12 lg:col-6 my-auto flex flex-column lg:align-items-end text-center lg:text-right">
              <div
                className="flex align-items-center justify-content-center bg-blue-200 align-self-center lg:align-self-end"
                style={{
                  width: "4.2rem",

                  height: "4.2rem",

                  borderRadius: "10px"
                }}
              >
                <i className="pi pi-fw pi-briefcase text-5xl text-blue-700"></i>
              </div>

              <h2 className="line-height-1 text-900 text-4xl font-normal">Stratejik Plan Çalışması</h2>

              <span className="text-700 text-xl line-height-3 ml-0 md:ml-2" style={{ maxWidth: "650px" }}>
                Stratejik Plan Çalışması alanımızda, kurumsal hedefleriniz doğrultusunda rehberlik alabilir, stratejik
                planlama süreci ve uygulama yöntemleri hakkında bilgi edinebilirsiniz.
              </span>

              <Button
                className="w-6 md:w-4 mt-4 bg-blue-200 text-blue-700 border-none "
                label="Sayfaya Git"
                icon="pi pi-check"
                onClick={() => navigate("/app/stratejik-plan")}
              />
            </div>
          </div>
        </div>

        <footer id="footer"
          style={{
            background: "#114d6b",
            color: "#fff",
            borderTop: "4px solid #e0e7ef",
            padding: "2.5rem 0 1.5rem 0",
            marginTop: "3rem"
          }}
        >
          <div className="container" style={{ maxWidth: 1200, margin: "0 auto", padding: "0 1rem" }}>
            <div className="grid justify-content-center">
              <div className="grid">
                <div className="col-12 md:col-6 mb-2">
                  <h4 className="font-semibold text-2xl mb-1" style={{ color: "#fff", borderBottom: "1px solid #fff", paddingBottom: 8 }}>
                    İletişim Bilgileri
                  </h4>
                  <div className="flex align-items-start mb-3 group">
                    <i className="pi pi-map-marker text-xl mr-3" style={{ color: "#c3e3fa" }}></i>
                    <a
                      href="https://maps.google.com/?q=TOBB+İkiz+Kuleleri+C+Kule+16.+Kat,+Mustafa+Kemal+Mah.+Eskişehir+Yolu+9.+Km,+No:+252+(Dumlupınar+Bulvarı)+06530+Çankaya+Ankara"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "#fff", textDecoration: "underline" }}
                    >
                      TOBB İkiz Kuleleri C Kule 16. Kat, Mustafa Kemal Mah. Eskişehir Yolu 9. Km, No: 252 (Dumlupınar Bulvarı) 06530 Çankaya / Ankara
                    </a>
                  </div>
                  <div className="flex align-items-center mb-3 group">
                    <i className="pi pi-phone text-xl mr-3" style={{ color: "#c3e3fa" }}></i>
                    <a href="tel:+903124191800" style={{ color: "#fff" }}>(312) 419 18 00</a>
                  </div>
                  <div className="flex align-items-center mb-3 group">
                    <i className="pi pi-print text-xl mr-3" style={{ color: "#c3e3fa" }}></i>
                    <a href="tel:+903124192700" style={{ color: "#fff" }}>(312) 419 27 00</a>
                  </div>
                  <div className="flex align-items-center mb-3 group">
                    <i className="pi pi-envelope text-xl mr-3" style={{ color: "#c3e3fa" }}></i>
                    <a href="mailto:info@osbuk.org.tr" style={{ color: "#fff" }}>info@osbuk.org.tr</a>
                  </div>
                  <div className="flex align-items-center group">
                    <i className="pi pi-inbox text-xl mr-3" style={{ color: "#c3e3fa" }}></i>
                    <a href="mailto:osbuk@hs01.kep.tr" style={{ color: "#fff" }}>KEP: osbuk@hs01.kep.tr</a>
                  </div>
                </div>
                <div className="col-12 md:col-6 mb-2">
                  <h4 className="font-semibold text-2xl mb-1" style={{ color: "#fff", borderBottom: "1px solid #fff", paddingBottom: 8 }}>
                    Resmi Web Siteleri
                  </h4>
                  <ul className="mb-6 list-none">
                    <li className="mb-3">
                      <a
                        href="https://osbuk.org/"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#fff", textDecoration: "underline" }}
                        className="flex md:justify-end items-center gap-2"
                      >
                        <span>OSBÜK</span>
                        <i className="pi pi-external-link text-sm"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.sanayi.gov.tr/anasayfa"
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#fff", textDecoration: "underline" }}
                        className="flex md:justify-end items-center gap-2"
                      >
                        <span>Sanayi ve Teknoloji Bakanlığı</span>
                        <i className="pi pi-external-link text-sm"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-12 md:col-4 mb-2">
                  <Link
                    to="/"
                    className="flex align-items-center cursor-pointer mb-4 hover:opacity-80 transition-opacity duration-300"
                  >
                    <img
                      src="images/medeasofticon.jpg"
                      alt="footer sections"
                      width="60"
                      height="60"
                      className="mr-3 rounded-lg shadow-md"
                    />
                    <span className="font-bold text-4xl" style={{ color: "#fff" }}>MedeaSoft</span>
                  </Link>
                </div>
                <div className="col-12 md:col-4 mb-2">
                  <div className="flex justify-content-center gap-4 mt-4">
                    <a
                      href="https://www.facebook.com/OSBustkurulusu/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-blue-300 transition-colors duration-300 p-2 hover:bg-blue-900 rounded-full"
                    >
                      <i className="pi pi-facebook text-2xl"></i>
                    </a>
                    <a
                      href="https://x.com/osbuk_org"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-blue-300 transition-colors duration-300 p-2 hover:bg-blue-900 rounded-full"
                    >
                      <i className="pi pi-twitter text-2xl"></i>
                    </a>
                    <a
                      href="https://www.instagram.com/osbuk_org/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-blue-300 transition-colors duration-300 p-2 hover:bg-blue-900 rounded-full"
                    >
                      <i className="pi pi-instagram text-2xl"></i>
                    </a>
                    <a
                      href="https://www.linkedin.com/company/osbukorg/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-blue-300 transition-colors duration-300 p-2 hover:bg-blue-900 rounded-full"
                    >
                      <i className="pi pi-linkedin text-2xl"></i>
                    </a>
                    <a
                      href="https://www.youtube.com/channel/UCIR6PiBQljY-q-njnYbEi1w"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-100 hover:text-blue-300 transition-colors duration-300 p-2 hover:bg-blue-900 rounded-full"
                    >
                      <i className="pi pi-youtube text-2xl"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "center", marginTop: 32, fontSize: 13, color: "#c3e3fa" }}>
              © {new Date().getFullYear()} OSBÜK | Tüm hakları saklıdır.
            </div>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default LandingPage;
